import { translate } from '../../../common/intl';
import { ColumnDefinition } from '../../components/KendoDataGrid/KendoDataGrid.types';
import GroupsCellTemplate from './components/GroupCellTemplate';
import TextCellTemplate from './components/TextCellTemplate';

export default function createSchema (
): Array<ColumnDefinition<{}>> {
  return [
    {
      id: 'lotNumber',
      field: 'lotNumber',
      title: translate('form.builder.deviation.affected.lot.number'),
      template: TextCellTemplate,
      width: 300,
    },
    // ponytail: Where Used is out of the first release (spec #26); the whereUsed flag is still saved
    {
      id: 'serialNumbers',
      field: 'serialNumbers',
      title: 'form.builder.deviation.affected.serial.numbers',
      editable: true,
      template: GroupsCellTemplate,
    },
  ];
}
